import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Trending(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.468 2c.158 0 .107.18.014.512l-.014.05a8.05 8.05 0 00-.14.582c-.153.792-.188 1.955.639 3.356.322.547.958 1.11 1.688 1.756 1.524 1.349 3.458 3.06 3.792 5.744.498 4-2.573 8-6.975 8C8.069 22 4.5 18.418 4.5 14c0-1.851.82-3.385 1.789-4.813a51.958 51.958 0 01.703-.996c.064-.09.114-.041.158.114.047.165.089.45.138.811l.02.142.024.178c.12.862.293 2.024.656 3.064.61 1.75 1.494 2.5 1.993 2.5.185 0 1.067-2.5 0-5-1.623-3.799.911-6.423 2.463-7.48.062-.042.121-.081.18-.118.416-.265.737-.402.844-.402zm-1.226 1.954a6.566 6.566 0 00-.724.778c-.909 1.156-1.515 2.773-.618 4.875.62 1.45.669 2.885.544 3.947a6.74 6.74 0 01-.287 1.335 3.064 3.064 0 01-.2.476 1.467 1.467 0 01-.178.261 1.12 1.12 0 01-.217.194c-.096.065-.3.18-.581.18-.686 0-1.284-.457-1.704-.931-.463-.524-.895-1.27-1.233-2.24a13.73 13.73 0 01-.53-2.13C5.904 11.748 5.5 12.803 5.5 14c0 3.87 3.125 7 6.972 7 3.749 0 6.413-3.42 5.983-6.876-.206-1.655-1.14-2.91-2.262-4.017-.398-.392-.79-.739-1.179-1.083a60.77 60.77 0 01-.511-.456c-.515-.465-1.062-.99-1.398-1.56-.68-1.154-.873-2.196-.863-3.054z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Trending);
export default ForwardRef;